import moment from "moment";
import dayjs from "dayjs";

export const columnsInitial = [
  {
    title: "KPI Name",
    dataIndex: "kpi_name",
  },
  {
    title: "KPI value (%)",
    dataIndex: "kpi_value",
  },
  {
    title: "Competency (%)",
    dataIndex: "competency",
  },
  {
    title: "Benchmark (%)",
    dataIndex: "benchmark",
  },
];

export const initialKpiInputData = {
  kpi_name: null,
  start_date: null,
  end_date: null,
};

export const formatDate = (date) =>
  date ? moment(new Date(date)).format("YYYY-MM-DD") : null;

export const getDatePickerValue = (date) =>
  date
    ? dayjs(moment(new Date(date)).format("DD/MM/YYYY"), "DD/MM/YYYY")
    : null;
